<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style lang="less">
    @import url("assets/css/common/base.less");
    @import url('assets/css/common/font.less');
    @import url("assets/css/common/atomic.less");
</style>


// WEBPACK FOOTER //
// src/App.vue